"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcCommentsList = class UcCommentsList extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    parentId;
    onParent_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parentId");
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    container;
    async $$load_container() {
        return this.$fn.fetch(`list_comment`, { parameters: { 'object-id': this.parentId || this.parent.id }, asResourceContainer: true });
    }
    ux;
    dataMembers = ['container', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                container: null,
                ux: {
                    initialLoadSpinner: true,
                },
            },
        };
    }
    get items() {
        if (this.loaded) {
            return this.container.data;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_2670_getActionArgs($event) {
        return {
            name: "WComment",
            props: {
                parentId: this.parentId,
                parent: this.parent,
                container: this.container,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_294572930540096_showModal_2672_getActionArgs($event) {
        return {
            name: "WComment",
            props: {
                parent: this.parent,
                container: this.container,
                item: $event.scope.item,
            },
        };
    }
    async evh_294572930540096_clickPreventStop(event, scope) {
        return await this.actions.evh_294572930540096_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3365375699802249_rest_2674_getActionArgs($event) {
        return {
            method: "delete",
            container: this.container,
            resource: $event.scope.item,
        };
    }
    async act_3365375699802249_rest_2674_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_3365375699802249_clickPreventStop(event, scope) {
        return await this.actions.evh_3365375699802249_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2668 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2667 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2668,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2667],
        });
        const act_8320016629450276_showModal_2670 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_2670_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_2669 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_2670,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_2669],
        });
        const act_294572930540096_showModal_2672 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_294572930540096_showModal_2672_getActionArgs,
            events: [],
        });
        const evh_294572930540096_clickPreventStop_2671 = new core_1.actions.EventHandlerImpl({
            action: act_294572930540096_showModal_2672,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_294572930540096_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_294572930540096_clickPreventStop_2671],
        });
        const act_3365375699802249_rest_2674 = new core_1.actions.RestAction({
            actionArgs: this.act_3365375699802249_rest_2674_getActionArgs,
            confirm: this.act_3365375699802249_rest_2674_getConfirm,
            events: [],
        });
        const evh_3365375699802249_clickPreventStop_2673 = new core_1.actions.EventHandlerImpl({
            action: act_3365375699802249_rest_2674,
            event: "click.prevent.stop",
            displayName: "rest",
        });
        const evh_3365375699802249_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3365375699802249_clickPreventStop_2673],
        });
        return {
            act_7315092382398562_reloadComponentData_2668,
            evh_7315092382398562_reload_2667,
            evh_7315092382398562_reload,
            act_8320016629450276_showModal_2670,
            evh_8320016629450276_clickPreventStop_2669,
            evh_8320016629450276_clickPreventStop,
            act_294572930540096_showModal_2672,
            evh_294572930540096_clickPreventStop_2671,
            evh_294572930540096_clickPreventStop,
            act_3365375699802249_rest_2674,
            evh_3365375699802249_clickPreventStop_2673,
            evh_3365375699802249_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcCommentsList.prototype, "parentId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parentId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcCommentsList.prototype, "onParent_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcCommentsList.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcCommentsList.prototype, "onParent", null);
UcCommentsList = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcCommentsList);
exports.default = UcCommentsList;
vue_property_decorator_1.Vue.component("UcCommentsList", UcCommentsList);
